<template>
<!-- 线上展厅 -->
<div class="scheme">
    <schemeBanner></schemeBanner>
    <schemeDone></schemeDone>
         <!-- <cs></cs> -->
    <schemeStrengths></schemeStrengths>

    <schemeBackstage></schemeBackstage>
   <schemeSystem></schemeSystem>
    <schemeCennert @handleChange="changeName"></schemeCennert>
    <paheFooter></paheFooter>
    <popUpwindow v-if="popUp_" :lin_k="link_" :codeid="codeid"  @close1="close1"></popUpwindow>
</div>
</template>
<script>
//引入线上展厅头部banner
import schemeBanner from '@/common/scheme/scheme-banner'
//引入我们能做什么模块
import schemeDone from '@/common/scheme/scheme-done'
//引入我们的优势
import schemeStrengths from '@/common/scheme/scheme-strengths'
//引入强大的系统功能
import schemeSystem from '@/common/scheme/scheme-system'

// 引入展示后台
import schemeBackstage from '@/common/scheme/scheme-backstage'
//引入线上解决方案
import schemeCennert from '@/common/scheme/scheme-cennert'
//引入底部
import paheFooter from '@/common/index/pahe-footer'
//引入案例弹窗
import popUpwindow from '@/common/public/pop-upwindow'
export default {
  components: {
    schemeBanner,
    schemeDone,
    schemeStrengths,
    schemeSystem,
    schemeBackstage,
    schemeCennert,
    paheFooter,
    popUpwindow,
  },
  // dom已经完成了
  data() {
        return {
           popUp_:false,
           link_:null,
           codeid:null,
           Pop_up_data:[
            
           ]
        }
  },
  methods:{
    changeName(link_){
      this.link_=link_.Model_link
      this.codeid=link_.codeid
      this.popUp_ = true
    },
    close1(){
      this.popUp_ = false
    }
  },
  mounted() {
    var schemeTop = localStorage.getItem('scheme_top');
    document.documentElement.scrollTop = schemeTop;
  },
  destroyed() {
    let i2 = document.documentElement.scrollTop;
    localStorage.setItem('scheme_top', i2)
  },
}
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/scheme.vue